import { Component, lazy } from 'react';

import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

import { ErrorBoundaryProps, ErrorBoundaryState } from './types';

const Page404 = lazy(() => import('@/pages/Page404'));

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidCatch() {
    sendGlobalErrorProps({
      errorType: 'generalError',
    });
  }

  render() {
    return this.state.hasError ? <Page404 /> : this.props.children;
  }
}
